(function () {
  if (window.__vhLoaded) return;
  window.__vhLoaded = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function q(s, c) { return (c || document).querySelector(s); }
  function qa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function closePanels() {
    qa('[data-vh-panel]').forEach(function (p) { p.hidden = true; });
    qa('[data-vh-add]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  function addToCart(id, btn) {
    var isPill = btn.hasAttribute('data-vh-var');
    var label = btn.textContent;
    btn.disabled = true;
    if (isPill) btn.textContent = '...';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        btn.disabled = false;
        if (isPill) btn.textContent = label;
        closePanels();
        if (state.status) { alert(state.description || 'No se ha podido a\u00f1adir. Int\u00e9ntalo de nuevo.'); return; }
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function' || !state.sections) { window.location.href = root + 'cart'; return; }
        state.id = id;
        drawer.renderContents(state);
      })
      .catch(function () { window.location.href = root + 'cart'; });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var nav = t.closest('[data-vh-prev],[data-vh-next]');
    if (nav) {
      var rail = nav.closest('[data-vh-rail]');
      var tr = rail && q('[data-vh-track]', rail);
      if (tr) tr.scrollBy({ left: (nav.hasAttribute('data-vh-next') ? 1 : -1) * tr.clientWidth * 0.85, behavior: 'smooth' });
      return;
    }
    var th = t.closest('[data-vh-thumb]');
    if (th) {
      var card = th.closest('[data-vh-card]');
      var m = q('[data-vh-main]', card);
      if (m) { m.removeAttribute('srcset'); m.src = th.getAttribute('data-vh-thumb'); }
      qa('[data-vh-thumb]', card).forEach(function (b) { b.classList.toggle('is-active', b === th); });
      return;
    }
    var add = t.closest('[data-vh-add]');
    if (add) {
      var v = add.getAttribute('data-variant');
      if (v) { addToCart(parseInt(v, 10), add); return; }
      var panel = q('[data-vh-panel]', add.closest('[data-vh-card]'));
      if (panel) {
        var willOpen = panel.hidden;
        closePanels();
        panel.hidden = !willOpen;
        add.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      }
      return;
    }
    var pill = t.closest('[data-vh-var]');
    if (pill && !pill.disabled) { addToCart(parseInt(pill.getAttribute('data-vh-var'), 10), pill); return; }
    if (!t.closest('[data-vh-panel]')) closePanels();
  });
  function initHero(h) {
    var tr = q('[data-vh-track]', h);
    var dots = qa('[data-vh-dot]', h);
    if (!tr) return;
    var n = tr.children.length;
    function idx() { return Math.round(tr.scrollLeft / tr.clientWidth); }
    tr.addEventListener('scroll', function () {
      var i = idx();
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }, { passive: true });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); }); });
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (n > 1 && !reduce && !(window.Shopify && Shopify.designMode)) {
      var timer = setInterval(function () { tr.scrollTo({ left: ((idx() + 1) % n) * tr.clientWidth, behavior: 'smooth' }); }, 6500);
      h.addEventListener('pointerdown', function () { clearInterval(timer); });
    }
  }
  function boot() { qa('[data-vh-hero]').forEach(initHero); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();